module.exports = __webpack_public_path__ + "img/7.38d5cca6.svg";